<template>
  <div>
    <van-field
      readonly
      clickable
      :value="$store.state.initialValue"
      name="picker"
      label="首字母"
      left-icon="alipay"
      placeholder="首字母默认搜索初中教材"
      @click="showPickerInitial = true"
  />
    <van-popup v-model="showPickerInitial" position="bottom" :style="{ height: '100%' }">
      <van-nav-bar
          title="搜索首字母"
          left-text="返回"
          right-text=""
          @click-left="onClickLeft"
          @click-right=""
      />
      <van-row type="flex" justify="space-between">
        <van-col span="6">
          <van-button type="default" size="normal" @click="initialOnConfirm">确定</van-button>
        </van-col>
        <van-col span="8" offset="2">
          <div style="color:lightsalmon;font-size:15px;margin-top: 10%">{{ showInitialResult }}</div>
        </van-col>
        <van-col span="4">
          <van-button type="default" size="normal" @click="clearInitialSelected">清空</van-button>
        </van-col>
      </van-row>
      <van-row>
      <van-search
          v-model="valueInitialSearch"
          placeholder="输入首字母"
          show-action
          input-align="center"
          @search="onSearchInitial"
          @cancel="onCancelInitial"
      />
      </van-row>
      <van-checkbox-group v-model="$store.state.initialSelected">
      <van-cell-group>
        <van-cell
            v-for="(initial, index) in initialColumns"
            clickable
            :key="initial"
            :title="`${initial}`"
            @click="toggleInitial(index)"
        >
          <template #right-icon>
            <van-checkbox :name="initial" ref="checkboxes"/>
          </template>
        </van-cell>
      </van-cell-group>
    </van-checkbox-group>
  </van-popup>

  </div>
</template>
<script>

export default {
  name: "initialSelect",
  props: [],
  data(){
    return {
      // 首字母
      showPickerInitial: false,
      initialColumns: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm',
                      'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v' , 'w', 'x', 'y', 'z'
                      ],
      valueInitialSearch: '',
      showInitialResult: '',
      valueChecked: [],

    }
  },
  methods:{
    // 搜索框
    onSearchInitial(){
      const t1 = this.valueInitialSearch.charCodeAt();
      const t2 = t1+32;
      const t3 = String.fromCharCode(t2);
      this.valueInitialSearch=this.valueInitialSearch>="A"&&this.valueInitialSearch<="Z"?(t3):this.valueInitialSearch;
      this.$store.state.initialSelected.push(this.valueInitialSearch);
      this.getShowInitialResult(this.valueInitialSearch);
    },
    onCancelInitial(){
      // 首字母搜索取消按钮
      this.valueInitialSearch = '';
    },
    initialOnConfirm(){
      // console.log(this.$store.state.initialSelected)
      this.getInitialValue(this.$store.state.initialSelected);
      this.valueInitialSearch = '';
      this.showPickerInitial = false
    },
    clearInitialSelected(){
      this.$store.state.initialSelected = [];
      this.$store.state.initialValue = "";
      this.valueInitialSearch = '';
      this.showInitialResult = '';
      this.valueChecked = [];
    },
    getShowInitialResult(valueInitial, flag = false){
      if(flag == false){
        this.valueChecked.push(valueInitial);
      }else{
        this.valueChecked.remove(valueInitial);
      };
      if(this.valueChecked.length == 0){
        this.showInitialResult = ''
      }else{
        this.showInitialResult = '选中 ' + this.valueChecked.toString();
      }
    },
    toggleInitial(index){
      this.$refs.checkboxes[index].toggle();
      this.getShowInitialResult(this.$refs.checkboxes[index].name, this.$refs.checkboxes[index].checked);
    },
    getInitialValue(initialList){
      if(initialList.length > 0){
        let initialNumber = initialList.length
        if(initialNumber == 1){
          this.$store.state.initialValue = initialList[0]
        }
        if(initialNumber == 2){
          this.$store.state.initialValue = initialList[0] + "," + initialList[1]
        }
        if(initialNumber > 2){
          this.$store.state.initialValue = initialList[0] + ','
              + initialList[1] + '等'
              + initialNumber + '个'
        }
      }
    },
    onClickLeft(){
      this.showPickerInitial = false
    },
  },
  watch: {
    // valueInitialSearch: {
    //   handler(newVal, oldVal) {
    //     if(newVal != ""){
    //
    //     }
    //   }
    // },
  },
  mounted() {
  }
}
Array.prototype.indexOf = function(val) {
  for (var i = 0; i < this.length; i++) {
    if (this[i] == val) {
      return i;
    }
  }
  return -1;
};
// 通过索引删除数组元素
Array.prototype.remove = function(val) {
  var index = this.indexOf(val);
  if (index > -1) {
    this.splice(index, 1);
  }
};
</script>

<style scoped>

</style>